(() => {
  'use strict';
  if (window.KinFabricJourney) return;
  const contextKeys = ['model', 'variant', 'preview_theme_id'];
  const fromKey = 'fabric_from', labelKey = 'fabric_from_label', browseKey = 'fabric_browse';
  const sofaPaths = new Set(['/pages/hay-mags-configurator', '/pages/hay-quilton-configurator']);
  const detail = document.querySelector('[data-fabric-page]');
  const index = document.querySelector('[data-fabrics-index]');
  const hay = !detail && document.querySelector('#fabric-library');
  const config = document.querySelector('script[data-fabric-journey]')?.dataset || {};
  const copy = {
    hay: config.backHay || 'Back to HAY fabrics',
    tradition: config.backTradition || 'Back to &Tradition fabrics',
    all: config.backAll || 'Back to all fabrics',
    short: config.allShort || 'All fabrics',
    source: config.backSource || 'Back to [source]',
    previous: config.backPrevious || 'Back to previous page'
  };
  const text = value => String(value || '').replace(/[\u0000-\u001f]/g, '').replace(/\s+/g, ' ').trim().slice(0, 100);
  function previewProductSource(url) {
    if (url.pathname !== '/products_preview' || !/^[a-f0-9]{32}$/i.test(url.searchParams.get('preview_key') || '') || !/^[1-9]\d{0,19}$/.test(url.searchParams.get('variant') || '') || url.hash !== '#aac-fabric-colours') return false;
    if (['preview_key', 'variant', 'colour', 'preview_theme_id'].some(key => url.searchParams.getAll(key).length > 1)) return false;
    const colour = url.searchParams.get('colour'), theme = url.searchParams.get('preview_theme_id');
    return (colour == null || colour.length <= 80 && !/[\u0000-\u001f<>]/.test(colour)) && (theme == null || /^[1-9]\d{0,19}$/.test(theme));
  }
  function localSource(raw) {
    if (typeof raw !== 'string' || raw.length > 2048 || !raw.startsWith('/') || raw.startsWith('//')) return null;
    try {
      const decoded = decodeURIComponent(raw);
      if (/^[\/]{2}|[\\\u0000-\u001f]/.test(decoded)) return null;
      const url = new URL(raw, location.origin);
      if (url.origin !== location.origin || !(/^\/(pages|products|collections|blogs)\//.test(url.pathname) || previewProductSource(url))) return null;
      if (detail && url.pathname === location.pathname && url.searchParams.get('view') === new URL(location.href).searchParams.get('view')) return null;
      return url;
    } catch { return null; }
  }
  // The planner remains the only design serializer/parser. This bounded read
  // identifies HAY transport context; it grants no fabric or purchase readiness.
  function sofaSource(url) {
    if (!url || !sofaPaths.has(url.pathname) || !/^#plan=[A-Za-z0-9_-]+={0,2}$/.test(url.hash)) return null;
    try {
      const plan = JSON.parse(decodeURIComponent(Array.from(atob(url.hash.slice(6).replace(/-/g, '+').replace(/_/g, '/')), c => '%' + c.charCodeAt(0).toString(16).padStart(2, '0')).join('')));
      const mags = url.pathname === '/pages/hay-mags-configurator';
      const families = mags ? ['mags', 'mags-low', 'mags-soft', 'mags-soft-low', 'mags-soft-low-removable'] : ['quilton', 'quilton-freestanding', 'quilton-lift'];
      if (!(mags ? [1, 2].includes(plan.v) : plan.v === 1 && plan.k === 'quilton') || !families.includes(mags && plan.v === 1 ? 'mags-soft-low-removable' : plan.g) || !Array.isArray(plan.m) || plan.m.length > 10 || plan.m.some(code => typeof code !== 'string' || code.length > 40) || typeof plan.f !== 'string' || plan.f.length > 80 || plan.c != null && (typeof plan.c !== 'string' || plan.c.length > 80 || /[\x00-\x1f<>]/.test(plan.c))) return null;
      return url;
    } catch { return null; }
  }
  function sourceLabel(url, supplied) {
    if (sofaSource(url)) return 'Back to your ' + (url.pathname.includes('mags') ? 'Mags' : 'Quilton') + ' sofa';
    const view = url.searchParams.get('view') || '';
    if (url.pathname === '/pages/fabrics' || view === 'kin-fabric-index') return copy.all;
    if (url.pathname === '/pages/andtradition-fabrics' || view === 'kin-andtradition-fabrics') return copy.tradition;
    if (url.pathname === '/pages/hay-fabric-options' && !view) return copy.hay;
    return supplied ? copy.source.replace('[source]', text(supplied)) : copy.previous;
  }
  const initial = new URL(location.href);
  let legacyCanonical = null;
  if (!detail && initial.pathname === '/pages/hay-fabric-options' && /^kin-fabric-/.test(initial.searchParams.get('view') || '')) {
    try {
      const mapped = JSON.parse(document.getElementById('kin-fabric-catalogue')?.textContent || '{}').legacyViews?.[initial.searchParams.get('view')];
      const destination = typeof mapped === 'string' ? new URL(mapped, location.origin) : null;
      if (destination?.origin === location.origin && /^\/pages\/fabric-[a-z0-9-]+$/.test(destination.pathname) && !destination.search && !destination.hash) legacyCanonical = destination.href;
    } catch {}
  }
  let origin = localSource(initial.searchParams.get(fromKey));
  let originTitle = text(initial.searchParams.get(labelKey));
  if (!origin && (detail || legacyCanonical) && document.referrer) {
    try {
      const referrer = new URL(document.referrer);
      if (referrer.origin === location.origin) origin = localSource(referrer.pathname + referrer.search + referrer.hash);
    } catch {}
  }
  const sofa = sofaSource(origin);
  if (origin && sofaPaths.has(origin.pathname) && !sofa) origin = null;
  const product = origin && (origin.pathname.startsWith('/products/') || previewProductSource(origin)) ? origin : null;
  let browse = localSource(initial.searchParams.get(browseKey));
  if (browse && !['/pages/hay-fabric-options', '/pages/fabrics'].includes(browse.pathname)) browse = null;
  const sofaFabricNames = (initial.searchParams.get('sofa_fabrics') || '').split(',').filter(name => name && name.length <= 80).slice(0, 60);
  function context(url) {
    const current = new URL(location.href);
    for (const key of contextKeys) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    const theme = window.Shopify?.theme;
    if (!current.searchParams.has('preview_theme_id') && theme?.role === 'unpublished' && /^\d+$/.test(String(theme.id))) url.searchParams.set('preview_theme_id', String(theme.id));
    return url;
  }
  function productReturn() {
    const url = new URL(product.href);
    if (!url.searchParams.has('preview_theme_id')) {
      const preview = context(new URL(product.href)).searchParams.get('preview_theme_id');
      if (/^[1-9]\d{0,19}$/.test(preview || '')) url.searchParams.set('preview_theme_id', preview);
    }
    return url;
  }
  const relative = url => url.pathname + url.search + url.hash;
  function browseSource(card) {
    const url = new URL(location.href);
    url.searchParams.delete(fromKey); url.searchParams.delete(labelKey);
    for (const key of [browseKey, 'sofa_fabrics', 'sample_request', 'sample_fabric', 'sample_colour', 'colour']) url.searchParams.delete(key);
    url.hash = card?.id || (hay ? 'fabric-library' : 'fabric-directory');
    return url;
  }
  function isFabric(url) {
    return url.pathname.startsWith('/pages/fabric-') || /^kin-fabric-(?!index$)/.test(url.searchParams.get('view') || '');
  }
  function link(path, card) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return url.href;
    context(url);
    const fabricDestination = isFabric(url), guideDestination = ['/pages/hay-fabric-options', '/pages/fabrics'].includes(url.pathname);
    if ((sofa || product) && (fabricDestination || guideDestination)) {
      url.searchParams.set(fromKey, relative(sofa || product));
      const label = sofa ? 'your ' + (sofa.pathname.includes('mags') ? 'Mags' : 'Quilton') + ' sofa' : originTitle;
      if (label) url.searchParams.set(labelKey, label); else url.searchParams.delete(labelKey);
      if (sofa && sofaFabricNames.length) url.searchParams.set('sofa_fabrics', sofaFabricNames.join(','));
      if (product) url.searchParams.delete('sofa_fabrics');
      const immediate = detail ? browse : (index || hay ? browseSource(card) : null);
      if (immediate) url.searchParams.set(browseKey, relative(immediate));
    } else if (fabricDestination) {
      const source = detail ? origin : (index || hay ? browseSource(card) : null);
      url.searchParams.delete(fromKey); url.searchParams.delete(labelKey);
      if (source) {
        url.searchParams.set(fromKey, relative(source));
        const title = detail ? originTitle : text(document.querySelector('main h1')?.textContent);
        if (title) url.searchParams.set(labelKey, title);
      }
    }
    return url.href;
  }
  function applyOrigin() {
    const navOrigin = sofa || product ? browse : origin;
    const libraryOrigin = navOrigin && (navOrigin.pathname === '/pages/fabrics' || navOrigin.searchParams.get('view') === 'kin-fabric-index');
    document.querySelectorAll('[data-fabric-origin-link]').forEach(anchor => {
      anchor.hidden = !navOrigin || libraryOrigin;
      if (!navOrigin) return;
      anchor.href = link(navOrigin.href);
      anchor.querySelector('span').textContent = sourceLabel(navOrigin, sofa ? '' : originTitle);
    });
    document.querySelectorAll('[data-fabric-library-link]').forEach(anchor => {
      if (!detail) { anchor.href = link(anchor.href); return; }
      anchor.href = libraryOrigin ? link(navOrigin.href) : link('/pages/fabrics');
      anchor.querySelector('span').textContent = origin && !libraryOrigin ? copy.short : copy.all;
    });
    if (sofa && !document.querySelector('[data-sofa-return]')) {
      const anchor = document.createElement('a'); anchor.className = 'kin-colour-link'; anchor.dataset.sofaReturn = '';
      const words = document.createElement('span'), arrow = document.createElement('span');
      words.textContent = sourceLabel(sofa, ''); arrow.textContent = '→'; arrow.setAttribute('aria-hidden', 'true'); anchor.append(words, arrow);
      anchor.href = context(new URL(sofa.href)).href;
      const nav = document.querySelector('.kin-fabric-library-nav');
      if (nav) nav.append(anchor);
      else { const line = document.createElement('p'); line.className = 'kf-journey-return'; line.append(anchor); (document.querySelector('#fabric-library .kf-heading') || document.querySelector('#kin-fabrics'))?.prepend(line); }
    }
    if (product) {
      let anchor = document.querySelector('[data-product-return]');
      if (!anchor) {
        anchor = document.createElement('a'); anchor.className = 'kin-colour-link'; anchor.dataset.productReturn = '';
        const words = document.createElement('span'), arrow = document.createElement('span');
        arrow.textContent = '→'; arrow.setAttribute('aria-hidden', 'true'); anchor.append(words, arrow);
        const nav = document.querySelector('.kin-fabric-library-nav');
        if (nav) nav.append(anchor);
        else { const line = document.createElement('p'); line.className = 'kf-journey-return' + (index ? ' kin-fabrics-index__container' : ''); line.append(anchor); (document.querySelector('#fabric-library .kf-heading') || document.querySelector('#kin-fabrics') || index)?.prepend(line); }
      }
      anchor.href = productReturn().href;
      anchor.querySelector('span').textContent = sourceLabel(product, originTitle);
    }
    if (origin) document.querySelectorAll('[data-fabric-return]').forEach(anchor => {
      anchor.href = product ? productReturn().href : context(new URL(origin.href)).href;
      const words = anchor.querySelector('.kf-action-label,span');
      if (words) words.textContent = sourceLabel(origin, originTitle);
    });
  }
  function refresh(scope = document) {
    scope.querySelectorAll('[data-fabric-link],[data-fabric-explore],[data-kin-colour-open],[data-preserve-context]').forEach(anchor => {
      anchor.href = link(anchor.href, anchor.closest('[data-fabric-card]'));
    });
    applyOrigin();
  }
  function formReturn() {
    const current = new URL(location.href), kept = new URLSearchParams();
    for (const key of ['view', 'colour', 'fabric_search', 'fabric_maker', 'fabric_group', ...contextKeys]) {
      if (current.searchParams.has(key)) kept.set(key, current.searchParams.get(key));
    }
    if (origin) {
      kept.set(fromKey, relative(origin));
      if (originTitle) kept.set(labelKey, originTitle);
    }
    if ((sofa || product) && browse) kept.set(browseKey, relative(browse));
    if (sofa && sofaFabricNames.length) kept.set('sofa_fabrics', sofaFabricNames.join(','));
    return current.pathname + (kept.size ? '?' + kept.toString() : '') + '#kf-sample-request';
  }
  function setBrowse(values) {
    const url = new URL(location.href);
    for (const [key, value] of Object.entries(values)) {
      if (!['fabric_search', 'fabric_maker', 'fabric_group'].includes(key)) continue;
      const clean = text(value);
      if (clean) url.searchParams.set(key, clean); else url.searchParams.delete(key);
    }
    history.replaceState(null, '', url);
    refresh();
  }
  function setProduct(title, path) {
    if (!origin) return;
    const product = new URL(path, location.origin);
    if (origin.origin === product.origin && origin.pathname === product.pathname) { originTitle = text(title); applyOrigin(); }
  }
  function sofaReturn(fabric, code) {
    if (!sofa || !fabric || typeof code !== 'string' || !code || code.length > 80 || /[\x00-\x1f<>]/.test(code)) return null;
    const url = context(new URL(sofa.href));
    url.searchParams.set('kin_apply', '1'); url.searchParams.set('kin_fabric', fabric.handle); url.searchParams.set('kin_colour', code);
    return url.href;
  }
  window.KinFabricJourney = {link, refresh, setBrowse, formReturn, setProduct, sofaReturn,
    get hasOrigin() { return !!origin; }, get sofaOrigin() { return !!sofa; },
    get sofaPlanUrl() { if (!sofa) return ''; const url = new URL(sofa.href); url.search = ''; return url.href; },
    get sofaFabricNames() { return sofa ? [...sofaFabricNames] : []; }
  };
  const fabricCanonical = detail?.dataset.fabricCanonical || legacyCanonical;
  if (fabricCanonical) {
    const canonical = new URL(fabricCanonical, location.origin);
    if (canonical.origin === location.origin && canonical.pathname !== location.pathname && /^kin-fabric-/.test(initial.searchParams.get('view') || '')) {
      for (const key of ['colour', ...contextKeys]) if (initial.searchParams.has(key)) canonical.searchParams.set(key, initial.searchParams.get(key));
      if (origin) { canonical.searchParams.set(fromKey, relative(origin)); if (originTitle) canonical.searchParams.set(labelKey, originTitle); }
      if ((sofa || product) && browse) canonical.searchParams.set(browseKey, relative(browse));
      if (sofa && sofaFabricNames.length) canonical.searchParams.set('sofa_fabrics', sofaFabricNames.join(','));
      for (const key of ['sample_request', 'sample_fabric', 'sample_colour']) if (initial.searchParams.has(key)) canonical.searchParams.set(key, initial.searchParams.get(key));
      canonical.hash = initial.hash;
      location.replace(canonical.href);
      return;
    }
  }
  refresh();
  document.addEventListener('shopify:section:load', event => refresh(event.target));
})();
